var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBurger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666504 1.91667C0.666504 1.13426 1.30077 0.5 2.08317 0.5H21.9165C22.6989 0.5 23.3332 1.13426 23.3332 1.91667C23.3332 2.69907 22.6989 3.33333 21.9165 3.33333H2.08317C1.30077 3.33333 0.666504 2.69907 0.666504 1.91667ZM0.666504 9C0.666504 8.2176 1.30077 7.58333 2.08317 7.58333H21.9165C22.6989 7.58333 23.3332 8.2176 23.3332 9C23.3332 9.7824 22.6989 10.4167 21.9165 10.4167H2.08317C1.30077 10.4167 0.666504 9.7824 0.666504 9ZM0.666504 16.0833C0.666504 15.3009 1.30077 14.6667 2.08317 14.6667H21.9165C22.6989 14.6667 23.3332 15.3009 23.3332 16.0833C23.3332 16.8657 22.6989 17.5 21.9165 17.5H2.08317C1.30077 17.5 0.666504 16.8657 0.666504 16.0833Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.cd06045e908fff21d13afb26e239b6fc.svg";
export { ForwardRef as ReactComponent };